// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "-legacy." + {"132":"9321be25","354":"024f89c5","368":"90f0e03d","445":"cafd5c7e","624":"0c09e112","738":"58c828b7","838":"3787910e"}[chunkId] + ".js";
};